<template>
  <ui-modal
    v-if="store.state.main.authException"
    :notification="true"
    :close="close"
  >
    <div class="modal-header">
      <h5 class="modal-title">Произошла ошибка</h5>

      <button class="btn-close" @click="close"></button>
    </div>

    <div class="modal-body">
      <!-- Обрабатываем ошибки Ру-Токена -->
      <div
        v-if="store.state.main.authException === 'RU_TOKEN_EXTENSION_NOT_FOUND'"
      >
        <a
          href="https://www.rutoken.ru/products/all/rutoken-plugin/"
          target="_blank"
          >Рутокен Плагин</a
        >
        необходим для связи USB-устройств c браузером, он позволяет
        <br />опознавать устройства и работать с ними.<br /><br />

        Чтобы установить плагин, необходимо загрузить соответствующий
        установочный файл и запустить его. Следуйте указанным на экране
        рекомендациям и после завершения процесса установки подключите
        USB-устройство в свободный USB-порт компьютера. Подробнее
        <a
          href="https://www.rutoken.ru/products/all/rutoken-plugin/"
          target="_blank"
          >тут</a
        >
      </div>
      <div
        v-else-if="
          store.state.main.authException === 'RU_TOKEN_NOT_DEVICES_CONNECTED'
        "
      >
        Нет подключенных USB устройств. Пожалуйста, вставьте устройтво Рутокен в
        USB порт и повторите попытку
      </div>

      <!-- Обрабатываем ошибки Крипто-Про -->
      <div
        v-else-if="
          store.state.main.authException === 'CRYPTO_PRO_EXTENSION_NOT_FOUND'
        "
      >
        <a href="https://www.cryptopro.ru/products/cades/plugin" target="_blank"
          >КриптоПро ЭЦП Browser plug-in</a
        >
        предназначен для создания и проверки электронной подписи (ЭП) на
        веб-страницах и поддерживает работу с широким набором алгоритмов, как
        встроенных в операционную систему, так и доустановленных дополнительно.
        Подробнее
        <a href="https://www.cryptopro.ru/products/cades/plugin" target="_blank"
          >тут</a
        >
      </div>

      <!-- Обрабатываем ошибки JAKARTA -->
      <div
        v-else-if="
          store.state.main.authException === 'JAKARTA_EXTENSION_NOT_FOUND'
        "
      >
        <a href="https://www.aladdin-rd.ru/catalog/jcwebclient/" target="_blank"
          >JC-WebClient</a
        >
        необходим для связи USB-устройств c браузером, он позволяет
        <br />опознавать устройства и работать с ними.<br /><br />

        Чтобы установить плагин, необходимо загрузить соответствующий
        установочный файл и запустить его. Следуйте указанным на экране
        рекомендациям и после завершения процесса установки подключите
        USB-устройство в свободный USB-порт компьютера. Подробнее
        <a href="https://www.aladdin-rd.ru/catalog/jcwebclient/" target="_blank"
          >тут</a
        >
      </div>

      <!-- Обрабатываем ошибки общие -->
      <div
        v-else-if="store.state.main.authException === 'CERTIFICATES_NOT_FOUND'"
      >
        Нет доступных сертификатов
      </div>

      <div v-else>
        {{ store.state.main.authException }}
      </div>
    </div>
  </ui-modal>

  <div v-if="getLoading" class="page-center">
    <div class="page-center-box text-center">
      <Logo />
      <ui-loading-page class="mt-4" />
    </div>
  </div>
  <router-view v-else />
</template>
<!-- 
<script>
import Logo from "@/assets/svg/LogoLogin.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    Logo,
  },
  created() {
    document.title = "STONE-XXI";
  },
  computed: {
    ...mapGetters({
      getLoading: "main/getLoading",
      getRoot: "main/getRoot",
    }),
  },
};
</script> -->


<script setup>
import Logo from "@/assets/svg/LogoLogin.vue";
import { useStore } from "vuex";
import { computed, onMounted, onBeforeUnmount } from "vue";

const store = useStore();

onMounted(() => {
  document.title = "STONE-XXI";
});

const getLoading = computed(() => store.getters["main/getLoading"]);
// const getRoot = computed(() => store.getters["main/getRoot"]);

const close = () => {
  store.commit("main/setAuthException", false);
};
</script>